import React from 'react';
import { VideoCameraOutlined } from '@ant-design/icons';

const VideoCameraIcon = () => <VideoCameraOutlined style={{ fontSize: 32 }} />;

export default VideoCameraIcon;
